import React from 'react';
import { ChannelLayout } from 'core/models/channel';
import { exportLatencyData } from 'services/latency/exportLatencyData';
import { useAutomaticLatencyMeasurement } from 'services/latency/useAutomaticLatencyMeasurement';
import { AutomaticLatencyMeasurePanel } from 'components/views/molecules/AutomaticLatencyMeasurePanel';
import NewWindow from 'react-new-window';

export type AutomaticLatencyMeasureWindowProps = {
    layout: ChannelLayout | undefined;
    onClose?: () => void;
};

export function AutomaticLatencyMeasureWindow(props: AutomaticLatencyMeasureWindowProps) {
    const { layout, onClose } = props;

    const { points, start, stop, reset } = useAutomaticLatencyMeasurement(layout);

    return (
        <NewWindow onUnload={onClose} copyStyles={true}>
            <AutomaticLatencyMeasurePanel
                points={points}
                onStart={start}
                onStop={stop}
                onReset={reset}
                onSave={() => exportLatencyData(points)}
            />
        </NewWindow>
    );
}
